import { swoopAPI } from '@/api'

export const createPlaidLinkToken = (companyId, data) => swoopAPI.post(`/api/v1/plaid/${companyId}/link/token`, data)
export const exchangePlaidPublicToken = (companyId, data) => swoopAPI.post(`/api/v1/plaid/${companyId}/item`, data)
export const getPlaidItems = companyId => swoopAPI.get(`/api/v1/plaid/${companyId}/items`)
export const relinkPlaidItem = (companyId, itemId, data) => swoopAPI.patch(`/api/v1/plaid/${companyId}/${itemId}/link/token`, data)
export const updatePlaidItem = (companyId, itemId) => swoopAPI.patch(`/api/v1/plaid/${companyId}/item/${itemId}`)
export const deletePlaidItem = (companyId, itemId) => swoopAPI.delete(`/api/v1/plaid/${companyId}/item/${itemId}`)
